(function () {
  'use strict';

  function selectedVariant(root) {
    var data = root.querySelector('[data-product-variant-data]');
    if (!data) return null;
    try {
      var variants = JSON.parse(data.textContent);
      var currentId = String(root.dataset.currentVariantId || '');
      return variants.find(function (variant) {
        return String(variant.id) === currentId;
      }) || null;
    } catch (_) {
      return null;
    }
  }

  function statusLink(status, message) {
    status.replaceChildren();
    status.append(document.createTextNode(message + ' '));
    var link = document.createElement('a');
    link.href = '/pages/garage?view=garage';
    link.textContent = 'Open Project Garage';
    status.append(link);
  }

  function setButtonState(block, variant) {
    var button = block.querySelector('[data-garage-product-button]');
    if (!button) return;
    button.disabled = !variant;
    button.setAttribute(
      'aria-label',
      variant
        ? 'Save selected option ' + (variant.title || '') + ' to Project Garage'
        : 'Select a product option before saving to Project Garage'
    );
  }

  function initialize(block) {
    if (block.dataset.garageProductInitialized === 'true') return;
    block.dataset.garageProductInitialized = 'true';

    var root = block.closest('[data-product-root]');
    var button = block.querySelector('[data-garage-product-button]');
    var category = block.querySelector('[data-garage-product-category]');
    var status = block.querySelector('[data-garage-product-status]');
    if (!root || !button || !category || !status) return;

    setButtonState(block, selectedVariant(root));

    root.addEventListener('alliance:variant-change', function (event) {
      setButtonState(block, event.detail && event.detail.variant);
      status.textContent = '';
    });

    button.addEventListener('click', function () {
      var variant = selectedVariant(root);
      if (!variant) {
        status.textContent = 'Select a product option before saving.';
        return;
      }
      if (!window.AllianceGarage || typeof window.AllianceGarage.saveProduct !== 'function') {
        status.textContent = 'Project Garage is temporarily unavailable. Please try again.';
        return;
      }

      var result = window.AllianceGarage.saveProduct({
        category_key: category.value,
        product_id: root.dataset.productId,
        variant_id: variant.id,
        product_handle: root.dataset.productHandle,
        product_url: window.location.pathname + window.location.search,
        vendor: root.dataset.productVendor,
        title: root.dataset.productTitle + (variant.title && variant.title !== 'Default Title' ? ' — ' + variant.title : ''),
        sku: variant.sku,
        mpn: root.dataset.productMpn,
        image_url: root.dataset.productImage,
        price: Number(variant.price || 0) / 100,
        compare_at_price: Number(variant.compare_at_price || 0) / 100,
        availability: variant.available === false ? 'unavailable' : 'available',
        inventory_quantity: Number(variant.inventory_quantity || 0),
        special_order: root.dataset.specialOrder === 'true',
        availability_checked_at: new Date().toISOString(),
        currency: root.dataset.productCurrency || 'USD'
      });

      if (!result || !result.ok) {
        status.textContent = result && result.message
          ? result.message
          : 'This selected part could not be saved. Please try again.';
        return;
      }

      if (result.code === 'ALREADY_SAVED') {
        statusLink(status, 'This exact option is already in that Garage category.');
        return;
      }
      statusLink(
        status,
        result.persisted === false
          ? 'Saved for this visit only because browser storage is unavailable.'
          : 'Exact selected option saved.'
      );
    });
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll('[data-garage-product-save]').forEach(initialize);
  }

  initializeAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
